// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-BarChart-___styles__barChart {
  display: flex;
  flex: 1;
  height: 13px;
}

.app-components-BarChart-___styles__legend {
  font-size: 10px;
}
`, "",{"version":3,"sources":["webpack://./app/components/BarChart/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".barChart {\n  display: flex;\n  flex: 1;\n  height: 13px;\n}\n\n.legend {\n  font-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"barChart": `app-components-BarChart-___styles__barChart`,
	"legend": `app-components-BarChart-___styles__legend`
};
export default ___CSS_LOADER_EXPORT___;
